import React, { useState } from "react";
import "../../assets/css/style.css";
import "../../assets/css/login.css"


import ForgotForm from "../../components/login/forgotForm"

const ForgotPassword = () => {

    return (
        <div className="main">
            <ForgotForm />
        </div>

    );
};

export default ForgotPassword;